import { render } from "./ServiceMaterialsTab.vue?vue&type=template&id=7fbaa0a0"
import script from "./ServiceMaterialsTab.vue?vue&type=script&lang=js"
export * from "./ServiceMaterialsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__